import { SupportedChainId } from '../constants/chains';
var DEFAULT_NETWORKS = [
    SupportedChainId.MAINNET,
    SupportedChainId.ROPSTEN,
    SupportedChainId.RINKEBY,
    SupportedChainId.GOERLI,
    SupportedChainId.KOVAN,
];
export function constructSameAddressMap(address, additionalNetworks) {
    if (additionalNetworks === void 0) { additionalNetworks = []; }
    return DEFAULT_NETWORKS.concat(additionalNetworks).reduce(function (memo, chainId) {
        memo[chainId] = address;
        return memo;
    }, {});
}
